// extracted by mini-css-extract-plugin
module.exports = {"circle":"SkillLegend_circle__3aqai","legendContainer":"SkillLegend_legendContainer__LFIWk"};